import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AutoBindComponent from "../../common/AutoBindComponent";
import VRIndienenForm from "./VRIndienenForm";
import VRIndienenPageHelper from "./VRIndienenPageHelper";

import * as types from "../../../constants/ComponentConstants";

import * as indienenActions from "../../../actions/indienenVoortgangsrapportActions";
import * as layoutActions from "../../../actions/voortgangsrapportLayoutActions";
import * as documentActions from "../../../actions/documentActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import * as exceptionActions from "../../../actions/exceptionActions";

class VRIndienenPage extends AutoBindComponent {

    constructor(props, context) {
        super(props, context);

        this.state = {
            indienen: {},
            pdf: {},
            pollCount: 0
        };

        this.pageHelper = new VRIndienenPageHelper(this);
    }

    componentWillMount() {
        this.pageHelper.init();
    }

    componentWillUnmount() {
        this.pageHelper.unmount();
    }

    handleOnSave(event) {
        this.pageHelper.onSave(event);
    }

    handleOnGeneratePdf() {
        this.pageHelper.onGeneratePdf();
    }

    isReadyToRender() {
        return !!this.state.indienen
            && this.state.indienen.voortgangsrapportId;
    }

    render() {
        if (!this.isReadyToRender()) {
            return null;
        }
        return (<VRIndienenForm
            indienen={this.state.indienen}
            onSave={this.handleOnSave}
            color={types.COLOR_GREEN}
            pdf={this.state.pdf}
            isPollingDocument={this.state.timer ? true : false}
            generatePdf={this.handleOnGeneratePdf}
        />);
    }
}

function mapStateToProps(state, ownProps) {
    const vrProjectId = ownProps.params.vrProjectId;
    const vrLoaded = state.voortgangsrapportLoaded;

    return {
        indienen: state.indienen,
        vrProjectId: vrProjectId,
        vrLoaded
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadVRPageLayout, dispatch),
        getContent: bindActionCreators(documentActions.getVoortgangsrapportContent, dispatch),
        generatePdf: bindActionCreators(indienenActions.generatePdf, dispatch),
        confirmIndienen: bindActionCreators(indienenActions.confirmIndienen, dispatch),
        ajaxStarted: bindActionCreators(ajaxActions.started, dispatch),
        ajaxEnded: bindActionCreators(ajaxActions.ended, dispatch),
        ajaxFailed: bindActionCreators(ajaxActions.failed, dispatch),
        throwException: bindActionCreators(exceptionActions.throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VRIndienenPage);
